export const FETCH_COTIZACIONES_REQUEST = "FETCH_COTIZACIONES_REQUEST";
export const FETCH_COTIZACIONES_SUCCESS = "FETCH_COTIZACIONES_SUCCESS";
export const FETCH_COTIZACIONES_FAILURE = "FETCH_COTIZACIONES_FAILURE";

export const FETCH_COTIZACION_ONE_SUCCESS = "FETCH_COTIZACION_ONE_SUCCESS";
export const FETCH_COTIZACION_ONE_FAILURE = "FETCH_COTIZACION_ONE_FAILURE";
